<p-drawer
  [(visible)]="drawerVisible"
  position="right"
  [modal]="true"
  [dismissible]="true"
  [closeOnEscape]="true"
  [blockScroll]="true"
  styleClass="filters-sidebar"
  [style]="{ width: '400px' }"
  (onHide)="close()">
  <ng-template pTemplate="header">
    <div class="sidebar-header">
      <div class="header-left">
        <i class="pi pi-filter"></i>
        <span class="font-bold">Filtros</span>
      </div>
    </div>
  </ng-template>

  <div class="filter-content user-filter__body">
    <div class="mt-4">
      <app-select
        [label]="'Status'"
        [hasFilter]="false"
        [options]="statusOptions"
        [(ngModel)]="draft.status"></app-select>
    </div>
    <div class="mt-4">
      <app-select
        [label]="'Senha'"
        [hasFilter]="false"
        [options]="passwordOptions"
        [(ngModel)]="draft.password"></app-select>
      <p class="user-filter__help">
        "Link de senha vencido": ainda sem senha e o último link de criação já venceu.
      </p>
    </div>
    <div class="mt-4">
      <app-select
        [label]="'Perfil'"
        [hasFilter]="false"
        [options]="roleOptions"
        [(ngModel)]="draft.role"></app-select>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="user-filter__footer">
      <app-button
        [label]="'Limpar'"
        [theme]="'white'"
        [fitContent]="true"
        [noMargin]="true"
        (sendButtonClick)="clear()"></app-button>
      <app-button
        [label]="'Aplicar filtros'"
        [icon]="'pi pi-filter'"
        [fitContent]="true"
        [noMargin]="true"
        (sendButtonClick)="apply()"></app-button>
    </div>
  </ng-template>
</p-drawer>
